module.exports = __webpack_public_path__ + "static/Kyle-4fd18e538adce1ca9a663b675523cf17.jpg";